var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props),
    React.createElement(
      "title",
      null,
      "AccountsError"
    ),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M20.05 5.9v8.3l-5.9 5.8H6L.05 14.1V5.9L6 0h8.3zm-11.5 4.2a1.3 1.3 0 0 0 2.6 0v-4a1.3 1.3 0 0 0-2.6 0zm2.9 4.4a1.64 1.64 0 0 0-1.7-1.5 1.7 1.7 0 0 0-1.5 1.5 1.53 1.53 0 0 0 1.5 1.7 1.53 1.53 0 0 0 1.7-1.5c.1-.1.1-.1 0-.2z" })
  );
});


// WEBPACK FOOTER //
// ../src/icons/images/indicators/ErrorSmall.svg